

























import { Vue, Component } from 'vue-property-decorator';
import StatusWindow from 'modal-window/src/status-window';
import DialogModal, { DialogButton } from './model/dialogModal';
@Component({
  name: 'ui-dialog',
})
export default class UiDialogComponent extends Vue {
  type: string = '';
  visible = false;

  dialogModal: DialogModal = new DialogModal();
  getButtonStyle(item: DialogButton): Object {
    return {
      background: item.BgColor,
      color: item.Color,
    };
  }
  toModalType(): StatusWindow {
    // switch(this.dialogModal.Type) {
    //     // case
    // }
    return StatusWindow.Text;
  }
  onClose() {
    this.clickButton(undefined);
  }
  clickButton(result: any) {
    this.hide();
    this.$emit('change', result);
  }
  hide() {
    this.visible = false;
  }
  show(data: DialogModal) {
    this.dialogModal = data;
    this.visible = true;
  }

  mounted() {
    console.log('mounted');
  }
}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/plugins/dialog/ui-dialog.vue